module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.5 6.2766132\"><path d=\"M.674.742L5.25 4.933 9.823.743\" stroke-width=\"2\" stroke=\"#949494\" fill=\"none\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/arrow.svg
// module id = 5
// module chunks = 0